import { ChevronDownIcon, XSquareIcon } from '@/icons';
import type { FormListFieldData } from 'antd';
import { Flex, Form, Input, InputNumber, Radio, Select } from 'antd';

const Question = ({
  field,
  remove,
}: {
  field: FormListFieldData;
  remove: (index: number | number[]) => void;
}) => {
  const form = Form.useFormInstance();
  const options = Form.useWatch(['questions', field.name, 'options'], form);

  const questionType = Form.useWatch(
    ['questions', field.name, 'question_type'],
    form,
  );

  return (
    <div>
      <Flex gap={24} justify="space-between" align="start">
        <button
          type="button"
          className="cursor-pointer text-theme-primary text-xl mt-3"
          onClick={() => remove(field.name)}
        >
          <XSquareIcon />
        </button>
        <Form.Item
          label="Question"
          name={[field.name, 'title']}
          className="w-full"
          rules={[{ required: true, message: 'Please enter question' }]}
        >
          <Input placeholder="Enter question" />
        </Form.Item>
        <Form.Item
          label="Type"
          name={[field.name, 'question_type']}
          className="w-[120px] shrink-0"
          rules={[{ required: true, message: '[Required]' }]}
        >
          <Select
            placeholder="Select"
            suffixIcon={<ChevronDownIcon size={16} className="text-white" />}
            options={[
              { label: 'MCQ', value: 'mcq' },
              { label: 'Text', value: 'text' },
              { label: 'Attachment', value: 'attachment' },
            ]}
          />
        </Form.Item>
        <Form.Item
          label="Mark"
          name={[field.name, 'mark']}
          className="w-20 shrink-0"
          rules={[
            { required: true, message: '[Required]' },
            { type: 'number', min: 1, max: 100, message: 'Must 1-100' },
          ]}
        >
          <InputNumber type="number" placeholder="0" controls={false} />
        </Form.Item>
      </Flex>

      {!!(questionType === 'mcq') && (
        <div className="mt-6 p-6 rounded-lg border border-theme-gray-700 space-y-4">
          <Form.List
            name={[field.name, 'options']}
            initialValue={[{}, {}, {}, {}]}
          >
            {(fields) => (
              <>
                {fields.map((optionField) => (
                  <Flex gap={16} key={optionField.key}>
                    <Form.Item name={[optionField.name, 'is_correct']}>
                      <Radio
                        checked={options?.[optionField.name]?.is_correct}
                        onChange={() => {
                          const selectedIndex = optionField.name;
                          const updated = options.map(
                            (opt: any, idx: number) => ({
                              ...opt,
                              is_correct: idx === selectedIndex,
                            }),
                          );
                          form.setFieldValue(
                            ['questions', field.name, 'options'],
                            updated,
                          );
                        }}
                      />
                    </Form.Item>
                    <Form.Item
                      className="w-full"
                      name={[optionField.name, 'value']}
                    >
                      <Input placeholder="Enter option" />
                    </Form.Item>
                  </Flex>
                ))}
              </>
            )}
          </Form.List>
        </div>
      )}
    </div>
  );
};

export default Question;
